import moment from "moment-ferie-fr";
/*
 {
      utilisateurId: 32,
      name: 'Crédit Agricole',
      frequencyType: 'recurring',
      frequencySubType: 'monthly',
      referenceDate: 2022-11-02T23:00:00.000Z,
      montant: -8.88,
      produitName: 'Banque',
      produitId: 24,
      isProfit: 0,
      categorieName: "Charges d'exploitation",
      categorieId: 3,
      isActive: 1,
      frequenceId: 13,
      planId: 0,
      date: 'Feb 3, 2023 10:04 PM',
      mois: 3
    },

 */

const prepareFrequenceDataByWeek = (data, profit = false) => {
  const weekTable = new Map();

  data.forEach(frequenceData => {
    const { produit, date, montant } = frequenceData;
    const week = moment(date).week();

    if (!weekTable.has(produit)) {
      weekTable.set(produit, {});
    }

    if (weekTable.get(produit)[`previ-semaine-${week}`]) {
      //weekTable.get(produit)[`previ-semaine-${week}`].montant += frequenceData;
    } else {
      weekTable.get(produit)[`previ-semaine-${week}`] = frequenceData;
    }
  });

  console.log({ weekTable });
  return weekTable;
};

export default prepareFrequenceDataByWeek;
